import { Component } from '@angular/core';
import { LoginBoxComponent } from '../../components/login-box/login-box.component';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [
    LoginBoxComponent
  ],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss'
})
export class LoginPageComponent {

}
